/*
 * Note: This file is used to export all atoms components
 * so that we can import all atoms components from a single file
 * instead of importing each component individually
 * e.g. import { Button, buttonVariants } from '@/components/ui/atoms';
 * instead of import { Button, buttonVariants } from '@/components/ui/atoms/Button';
 */

import {
  baseButtonVariants,
  type IBaseButtonVariantProps,
} from "./baseButton/BaseButton"
import { Breadcrumb } from "./breadcrumb/Breadcrumb"
import { BurgerMenu } from "./burger-menu/burger-menu"
import { Button, type TButton } from "./button/Button"
import Chip from "./chip/Chip"
import Feature, { IFeatureProps } from "./feature/Feature"
import { Flag } from "./flag/Flag"
import FooterBottom from "./footer/footer-bottom/FooterBottom"
import FooterTopCard, {
  IFooterTopCardProps,
} from "./footer/footer-top-card/FooterTopCard"
import { GoBackButton } from "./go-back-button/GoBackButton"
import { Link, TLinkProps } from "./link/Link"
import { RemixIcon, type TIconSize } from "./remix-icon/RemixIcon"
import { RichTextSync } from "./rich-text/RichTextSync"
import { Tag, type TagProps } from "./tag/Tag"
import { TextInput, TTextInputProps } from "./text-input/TextInput"
import { ToggleMenuIcon } from "./toggler-menu-icon/ToggleMenuIcon"
import { Typography } from "./typography/Typography"

export {
  Breadcrumb,
  type TButton,
  Button,
  baseButtonVariants,
  type IBaseButtonVariantProps,
  Tag,
  Feature,
  type IFeatureProps,
  Flag,
  type TLinkProps,
  FooterTopCard,
  type IFooterTopCardProps,
  type TagProps,
  RemixIcon,
  type TIconSize,
  FooterBottom,
  Chip,
  Link,
  type TTextInputProps,
  TextInput,
  Typography,
  BurgerMenu,
  ToggleMenuIcon,
  RichTextSync,
  GoBackButton,
}
